<template>
    <div class="store-modal">
        <a
            >　/<span
                @click="showItemList"
                style="font-size: 15px; cursor: pointer"
                >一覧を見る</span
            ></a
        >

        <button
            class="btn btn-danger totalBox__btn"
            data-toggle="modal"
            data-target="#professional-item-modal"
        >
            item
        </button>

        <confirm-modal
            modal-id="professional-item-modal"
            title="キャンセル確認"
            ok-text="注文をキャンセルする"
        >
            popopopoppop
        </confirm-modal>

        <!--        <transition name="modal">-->
        <!--            <div v-if="showModal" class="professional-modal">-->
        <!--                <div class="modal-mask">-->
        <!--                    <div class="modal-dialog" role="document">-->
        <!--                        <div class="modal-content">-->
        <!--                            <div class="modal-header">-->
        <!--                                <h2 class="product-title">{{tableName}}一覧</h2>-->
        <!--                                <button @click="showModal=false"><i class="fa fa-close"></i></button>-->
        <!--                            </div>-->

        <!--                            <div class="modal-body">-->
        <!--                                <div class="alert alert-info alert-box col-md-12" v-if="message">-->
        <!--                                    <div class="col-md-7" style="width:200px">{{message}}</div>-->
        <!--                                    <a href="/cart" class="btn btn-accent pull-right col-md-5" style="width:100px;padding:7px 10px 7px;">カート編集へ</a>-->
        <!--                                </div>-->

        <!--                                <overlay-loading :condition="() => busy"></overlay-loading>-->
        <!--                                <div class="row">-->
        <!--                                    <div v-for="item in items" class="col-xs-6 col-md-3 mb-5">-->
        <!--                                        <a class="product-image-link category-img">-->
        <!--                                            <div style="position:relative;">-->
        <!--                                                <img v-if="item.image" :src="item.image.path" alt="Product Image">-->
        <!--                                                <img v-if="!item.image" src="/img/noimage.png" alt="Product Image">-->
        <!--                                                <p v-if="item.count != 1" class="table-item-count">×{{item.count}}</p>-->
        <!--                                                <p v-else class="table-item-count" style="height: 24px;"></p>-->
        <!--                                            </div>-->
        <!--                                        </a>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->

        <!--                            <div class="modal-footer">-->
        <!--                                <div class="col-md-12 cart-box">-->
        <!--                                    <div class="item product-quantity-item" style="z-index: 0;">-->
        <!--                                        <input v-model="count" type="text"/>-->

        <!--                                        <span class="input-group-btn-vertical">-->
        <!--                                            <button @click="count++"-->
        <!--                                                    class="btn-up"-->
        <!--                                                    type="button">-->
        <!--                                                <i class="glyphicon glyphicon-plus"></i>-->
        <!--                                            </button>-->

        <!--                                            <button @click="(count > 0)? count&#45;&#45; : 0"-->
        <!--                                                    class="btn-down"-->
        <!--                                                    type="button">-->
        <!--                                                <i class="glyphicon glyphicon-minus"></i>-->
        <!--                                             </button>-->
        <!--                                        </span>-->
        <!--                                    </div>-->

        <!--                                    <div class="col-xs-4 col-md-4 product-price">-->
        <!--                                        ￥{{Number(priceJpy).toLocaleString()}}-->
        <!--                                    </div>-->

        <!--                                    <div class="col-md-3 p-0">-->
        <!--                                        <button :disabled="count === 0"-->
        <!--                                                v-btn-loading="btnBusy"-->
        <!--                                                class="btn-alltobag btn btn-accent text-center"-->
        <!--                                                style="z-index: 0;"-->
        <!--                                                @click="addCartTableSet()">-->
        <!--                                            まとめてレンタルする-->
        <!--                                        </button>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </transition>-->
    </div>
</template>

<script>
import OverlayLoading from '../../components/Admin/OverlayLoading.vue'
import BtnLoading from '../../directives/BtnLoading.vue'
import linq from 'linq'
import ConfirmModal from '../ConfirmModal.vue'

export default {
    data() {
        return {
            busy: false,
            btnBusy: false,
            showModal: false,
            objTableSet: JSON.parse(this.tableSet),
            items: [],
            message: '',
            count: 0,
        }
    },

    props: {
        tableName: {
            type: String,
        },
        tableSet: {
            type: String,
        },
        priceJpy: {
            type: String,
        },
    },

    created() {},

    mounted() {},

    methods: {
        async getImage() {
            this.busy = true
            try {
                const { data } = await axios.get(
                    `/api/collection-table-set-items/${this.objTableSet.id}`
                )
                this.items = data
            } finally {
                this.busy = false
            }
        },

        async showItemList() {
            this.showModal = true
            this.getImage()
        },

        async addCartTableSet() {
            this.btnBusy = true
            this.setMessage()
            const items = linq
                .from(this.items)
                .select((x) => {
                    return { item_id: x.item_id, count: x.count * this.count }
                })
                .toArray()
            await axios.post('/api/cart/add', items)
            this.count = 0

            this.addCartAction()
            this.setMessage('カートを更新しました')
            this.showModal = true
            this.btnBusy = false
        },

        addCartAction() {
            window.cartDrop.$emit('getCartItems')
        },

        setMessage(message = '') {
            this.message = message
        },
    },

    directives: {
        BtnLoading,
    },

    components: {
        ConfirmModal,
        OverlayLoading,
    },
}
</script>

<style lang="scss" scoped>
.store-modal {
    .alert-box {
        font:
            400 13px/2.15 'Poppins',
            sans-serif;
        display: inline-block;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        .modal-dialog {
            z-index: 9999;
        }
    }
    .modal-header {
        display: flex;
    }
    .modal-header h2 {
        margin-bottom: 0;
        font-size: 20px;
    }
    .modal-header button {
        position: absolute;
        right: 20px;
        top: 5px;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        width: auto;
    }

    .modal-body {
        margin: 20px 0;
        max-height: 70vh;
        overflow-y: scroll;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .cart-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        float: right;
        font-family: 'Poppins', sans-serif;
        font-weight: normal;
    }

    .item {
        margin-right: 15px;
        width: 20%;
        @media screen and (max-width: 576px) {
            margin-right: 12px;
        }
    }

    .filter-size-name {
        font-size: 13px;
        color: #000000;
        @media screen and (max-width: 576px) {
            min-width: 40px;
        }
    }

    .product-price {
        font-size: 17px;
        color: #000000;
        margin-left: 10px;
    }

    .btn-alltobag button {
        background-color: #fff;
        color: #000;
        font-weight: 700;
        &:hover {
            color: #fff;
            border-color: #262634;
            background-color: #262634;
        }
    }

    button {
        width: 100%;
        flex: unset;
        padding: 7px 10px 7px;
        font-weight: bold;
        @media screen and (max-width: 1127px) {
            font-size: 11px;
            padding: 7px 4px 7px;
        }
        @media screen and (max-width: 576px) {
            padding: 10px;
        }
    }

    .product-quantity-item {
        position: relative;
        display: inline-block;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        margin-right: 30px;
        padding-right: 0;
        input {
            margin-bottom: 0;
            width: 100%;
            height: 50px;
            text-align: center;
            border: 1px solid #dfdfdf;
            font-size: 14px;
            font-weight: 700;
            color: #262634;
            font-family: 'Oswald', sans-serif;
            padding: 14px 15px 14px;
        }
    }

    .input-group-btn-vertical {
        button {
            position: absolute;
            left: 100%;
            margin: 0 0 0 4px;
            width: 25px;
            height: 25px;
            padding: 0;
            color: #262634;
            font-size: 10px;
            text-align: center;
            border: 1px solid #dfdfdf;
            background-color: #ffffff;
            &:hover {
                color: #ffffff;
                border-color: #262634;
                background-color: #262634;
            }
        }
        .btn-up {
            top: 0;
            i {
                top: 6px;
            }
        }
        .btn-down {
            top: 26px;
            i {
                top: 6px;
            }
        }
    }

    img {
        height: 80px;
        object-fit: contain;
        margin: auto;
    }
}

@media all and (-ms-high-contrast: none) {
    .modal-mask {
        width: 100%;
    }
    .modal-dialog {
        position: absolute;
        top: 30%;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/professionalDesign/ProfessionalCollectionStoreModal.vue